import React from 'react';
import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import LanguageSwitcher from './LanguageSwitcher';
import { openCookieSettings } from './CookieConsent';

const Footer = () => {
  const { t } = useTranslation();
  return (
    <footer className="relative bg-[#0B1724] text-white overflow-hidden" data-testid="site-footer">
      <span aria-hidden className="absolute inset-x-0 top-0 h-px bg-gradient-to-r from-transparent via-[#e0b56a] to-transparent" />
      <span aria-hidden className="pointer-events-none absolute inset-0 opacity-[0.07] [background-image:radial-gradient(#e0b56a_1px,transparent_1px)] [background-size:22px_22px]" />
      <span aria-hidden className="pointer-events-none absolute -top-24 right-0 w-[520px] h-[260px] rounded-full bg-[#1B3A5C] blur-[90px] opacity-60" />
      <div className="relative max-w-7xl mx-auto px-6 lg:px-10 py-14">
        <div className="grid grid-cols-1 md:grid-cols-3 gap-8 mb-8">
          <div>
            <h4 className="mb-4"><img src="/assets/logo-gestapelt-hell.png" alt="Kanzlei Nabhan Gäbler &amp; Partner" className="h-28 w-auto select-none" draggable="false" loading="lazy" data-testid="footer-logo" /></h4>
            <p className="text-white/70 text-sm leading-relaxed">
              Bundeskanzlerplatz 2D<br />
              D-53113 Bonn
            </p>
            <div className="mt-4">
              <LanguageSwitcher variant="footer" />
            </div>
          </div>
          <div>
            <h4 className="text-[#e0b56a]/90 font-semibold tracking-[0.2em] text-xs mb-3">{t('footer.contact').toUpperCase()}</h4>
            <p className="text-white/70 text-sm">
              Tel.: +49 (0) 228 30 40 640<br />
              bonn@kanzlei-partner.com
            </p>
          </div>
          <div>
            <h4 className="text-[#e0b56a]/90 font-semibold tracking-[0.2em] text-xs mb-3">{t('footer.legal').toUpperCase()}</h4>
            <ul className="space-y-1.5 text-white/70 text-sm">
              <li><Link to="/impressum" data-testid="footer-impressum-link" className="hover:text-[#b8893d] transition-colors">{t('footer.imprint')}</Link></li>
              <li><Link to="/datenschutz" data-testid="footer-datenschutz-link" className="hover:text-[#b8893d] transition-colors">{t('footer.privacy')}</Link></li>
              <li><Link to="/agb" data-testid="footer-agb-link" className="hover:text-[#b8893d] transition-colors">{t('footer.terms')}</Link></li>
              <li>
                <button
                  type="button"
                  onClick={openCookieSettings}
                  data-testid="footer-cookie-settings-btn"
                  className="text-left hover:text-[#b8893d] transition-colors"
                >
                  {t('footer.cookie_settings', 'Cookie-Einstellungen')}
                </button>
              </li>
            </ul>
          </div>
        </div>
        <div className="border-t border-white/10 pt-6 pb-14 md:pb-0 flex flex-col md:flex-row justify-between items-center gap-3">
          <p className="text-white/50 text-xs tracking-wide">
            © {new Date().getFullYear()} Kanzlei Nabhan Gäbler &amp; Partner. {t('footer.rights')}.
          </p>
          <a
            href="#top"
            onClick={(e) => { e.preventDefault(); window.scrollTo({ top: 0, behavior: 'smooth' }); }}
            className="text-[#b8893d] hover:text-white text-xs tracking-[0.2em] transition-colors"
          >
            {t('footer.back_to_top').toUpperCase()} ↑
          </a>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
